import { useDivergenciasEquipeDialogs } from "./use-divergencias-equipe-dialogs";
import { DivergenciasEquipeDialogsView } from "./view-divergencias-equipe-dialogs";
import type { DivergenciasEquipeDialogsProps } from "./types-divergencias-equipe-dialogs";

export function DivergenciasEquipeDialogs(props: DivergenciasEquipeDialogsProps) {
  const vm = useDivergenciasEquipeDialogs(props);

  return <DivergenciasEquipeDialogsView {...props} {...vm} />;
}

export type * from "./types-divergencias-equipe-dialogs";
